import { render } from "./AdminSuppliesPanel.vue?vue&type=template&id=39cc081d&scoped=true"
import script from "./AdminSuppliesPanel.vue?vue&type=script&lang=js"
export * from "./AdminSuppliesPanel.vue?vue&type=script&lang=js"

import "./AdminSuppliesPanel.vue?vue&type=style&index=0&id=39cc081d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cc081d"]])

export default __exports__